<template>
	<div class="device-map">
		<div id="container" class="dmap" :class="{dmapShowAre:isAddDevice=='ADD'||isAddDevice=='EDIT'}">
			<i class="isdraw" v-show="isDetail">
				<img src="@/assets/images/public/public_copy.png" @click="changeToDraw" />
			</i>
			<div id="myPageTop" class="input-search" style="z-index: 199;">
				<el-input v-model="search_data" @input="searchAddress" id="tipinput">
				</el-input>
				<i class="el-icon-circle-close close" @click="closeSearch"></i>
				<div id='panel' class="panel" v-if="isSearch">
					
				</div>
			</div>
		</div>
		<div class="area" v-if="isAddDevice=='ADD'||isAddDevice=='EDIT'">
			<template v-if="!currentMark || address=='' || address==null">
				{{$t('terminal.mapTip1')}}
			</template>
			<template v-else>
				<div class="overflow-hidden" style="line-height: 20px;color: #0d8867;">{{$t('terminal.addDetail')}}:{{this.address}}</div>
				<div style="line-height: 20px;color: #58c8a9;">
					<span>{{`${$t('terminal.lng')}:${this.latlng[0]}`}}</span>
					<span style="margin-left: 20px;">{{`${$t('terminal.lat')}:${this.latlng[1]}`}}</span>
				</div>
			</template>
		</div>
		<device-detail :currentDetail='mapDeviceList[currentDeviceIndex]' :isMap='false' v-show="isShowDetail"
			v-if="isDetail && mapDeviceList[currentDeviceIndex]!=null" ref='infoWindow'>
		</device-detail>
	</div>
</template>

<script>
	import AMapLoader from '@amap/amap-jsapi-loader';
	import {
		runStateInfo
	} from "@/assets/scripts/runState";
	import {
		changeDeviceStateName
	} from "@/assets/scripts/changeDeviceStateName";
	import {
		mPagination
	} from "@/components/basics/mixins";
	import DeviceDetail from './DeviceDetail.vue';
	export default {
		name: "DeviceMap",
		mixins: [mPagination],
		components: {
			DeviceDetail
		},
		data() {
			return {
				map: null,
				mapType: "normal",
				currentMark: null,
				search_data: null,
				currentDeviceIndex: 0,
				isShowDetail: false,
				DeviceDetail: {},
				isOpenDevice: false,
				isSearch:false,
				isDraw: false,
				flag: false,
				singlemark: null,
				mapDeviceList: [],
				mouseTool: null,
				address: '',
				geocoder: null,
				latlng: [null, null],
				markDetail: {
					citycode: null,
					adcode: null,
					address: null,
					position: [null, null]
				},
				placeSearch: null
				//deviceList: []
			}
		},
		props: {
			deviceList: {
				type: Array,
				default: function() {
					return []
				}
			},
			deviceName: {
				type: String,
				default: ''
			},
			isDetail: {
				type: Boolean,
				default: true
			},
			isAddDevice: {
				type: String,
				default: 'none'
			},
			form: {
				type: Object
			}
		},
		mounted() {
			if (this.deviceList.length != 0) {
				this.deviceList.forEach(ele => {
					if (ele.lat !== null && ele.lng !== null && ele.lat != '0.0000000000') {
						ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
						ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
						this.mapDeviceList.push(ele);
					}
				})
			}
			setTimeout(() => {
				this.getGis();
			})
		},
		methods: {
			getGis() { //lat 是纬度，lng是经度
				let then = this;
				AMapLoader.load({
					"key": "46cb39d92c537b3b83da39e6da9e9f0e", // 申请好的Web端开发者Key，首次调用 load 时必填
					"version": "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
					"plugins": ['overlay/SimpleMarker', 'AMap.Geocoder',
						'AMap.MouseTool', 'AMap.PlaceSearch'
					], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
					"AMapUI": { // 是否加载 AMapUI，缺省不加载
						"version": '1.1', // AMapUI 缺省 1.1
						"plugins": [], // 需要加载的 AMapUI ui插件
					},
					// "Loca": { // 是否加载 Loca， 缺省不加载
					// 	"version": '1.3.2' // Loca 版本，缺省 1.3.2
					// },
				}).then(() => {
					//map = new AMap.Map('container');
				}).catch(e => {
					console.log(e);
				});
				if(this.isAddDevice == 'EDIT' && this.form.lng!==null && this.form.lng !== '0.0000000000'){
					let pos = [Number(this.form.lng),Number(this.form.lat)]
					console.log(pos)
					this.map = new AMap.Map('container',{
						resizeEnable: false,
						zoom:11,
						center:pos
					});
					console.log('edit',pos)
				}else{
					this.map = new AMap.Map('container');
				}
				

				this.geocoder = new AMap.Geocoder({
					city: "010", //城市设为北京，默认：“全国”
					radius: 1000 //范围，默认：500
				});

				if (this.isAddDevice == 'EDIT') {
					this.markDetail.position = [this.form.lng, this.form.lat];
					this.latlng = [Number(this.form.lng), Number(this.form.lat)];
					this.address = this.form.formattedAddress
					this.currentMark = new AMap.Marker({
						position: [Number(then.form.lng), Number(then.form.lat)],
					});
					this.currentMark.setLabel(({
						content: then.form.name,
						direction: 'bottom'
					}))
					this.map.add(this.currentMark)
				}
				new AMap.service(["AMap.PlaceSearch"], function() {
					//构造地点查询类
					then.placeSearch = new AMap.PlaceSearch({
						pageSize: 5, // 单页显示结果条数
						pageIndex: 1, // 页码
						citylimit: false, //是否强制限制在设置的城市内搜索
						map: then.map, // 展现结果的地图实例
						panel: "panel", // 结果列表将在此容器中进行展示。
						autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
						renderStyle: 'default'
					});
				});
				AMap.event.addListener(this.placeSearch, "selectChanged", this.selectAddress);
				AMapUI.loadUI(['overlay/SimpleMarker', 'overlay/SimpleInfoWindow'], function(SimpleMarker) {
					then.setDeviceSite(SimpleMarker);
					//启动页面
					//then.getDeviceList();
					//initPage(SimpleMarker);
					// let iconTheme = 'default';
					// function openInfoWin(mark) {
					// 	infoWindow.open(then.map, mark);
					// }
					// // 实现自定义窗体内容，返回拼接后的字符串
					// function createInfoWindow() {
					// 	// 内容拼接 ...
					// 	return then.$refs.infoWindow ? then.$refs.infoWindow.$el : null;
					// }
					// let infoWindow = new AMap.InfoWindow({
					// 	//infoBody: `<p>${then.deviceList[then.currentDeviceIndex].name}</p>`,
					// 	//基点指向marker的头部位置
					// 	isCustom: true,
					// 	// 只有当组件渲染完毕后，通过$el才能拿到原生的dom对象
					// 	content: createInfoWindow(),
					// 	offset: new AMap.Pixel(0, -31)
					// });
					// for (let i = 0; i < then.mapDeviceList.length; i++) {
					// 	let mark = new SimpleMarker({
					// 		iconTheme: iconTheme,
					// 		iconStyle: 'lightgray',
					// 		iconLabel: {
					// 			style: {
					// 				color: '#333'
					// 			}
					// 		},
					// 		map: then.map,
					// 		position: [Number(then.mapDeviceList[i].lng), Number(then.mapDeviceList[i].lat)],
					// 		label: {
					// 			content: then.mapDeviceList[i].name,
					// 			offset: new AMap.Pixel(27, 25)
					// 		}
					// 	})
					// 	mark.on('click', function() {
					// 		then.currentDeviceIndex = i;
					// 		then.isShowDetail = true;
					// 		//console.log('地址是.....',then.mapDeviceList[i]);
					// 		let pos = [then.mapDeviceList[i].lat, then.mapDeviceList[i].lng];
					// 		then.$emit('showAddress', pos, then.mapDeviceList[i].formattedAddress)
					// 		openInfoWin(mark.getPosition());
					// 	});
					// 	then.map.on('click', () => {
					// 		infoWindow.close()
					// 	})
					// 	openInfoWin();
					// }

				});
				this.addTools(this.map);
				this.getLng(this.map);

			},
			setDeviceSite(SimpleMarker){
				let then = this;
				let iconTheme = 'default';
				function openInfoWin(mark) {
					infoWindow.open(then.map, mark);
				}
				// 实现自定义窗体内容，返回拼接后的字符串
				function createInfoWindow() {
					return then.$refs.infoWindow ? then.$refs.infoWindow.$el : null;
				}
				let infoWindow = new AMap.InfoWindow({
					//infoBody: `<p>${then.deviceList[then.currentDeviceIndex].name}</p>`,
					//基点指向marker的头部位置
					isCustom: true,
					// 只有当组件渲染完毕后，通过$el才能拿到原生的dom对象
					content: createInfoWindow(),
					offset: new AMap.Pixel(0, -31)
				});
				for (let i = 0; i < then.mapDeviceList.length; i++) {
					let mark = new SimpleMarker({
						iconTheme: iconTheme,
						iconStyle: then.mapDeviceList[i].run_state == 0 ? 'red' : 'green',
						iconLabel: {
							style: {
								color: then.mapDeviceList[i].run_state == 0 ? 'red' : 'green'
							}
						},
						map: then.map,
						position: [Number(then.mapDeviceList[i].lng), Number(then.mapDeviceList[i].lat)],
						label: {
							content: then.mapDeviceList[i].name,
							offset: new AMap.Pixel(27, 25),
							style:{
								fontSize:25,
								fillColor:then.mapDeviceList[i].run_state == 0 ? 'red' : 'green',
								backgroundColor:then.mapDeviceList[i].run_state == 0 ? 'red' : 'green'
							}
						}
					})
					mark.on('click', function() {
						then.currentDeviceIndex = i;
						then.isShowDetail = true;
						//console.log('地址是.....',then.mapDeviceList[i]);
						let pos = [then.mapDeviceList[i].lng,then.mapDeviceList[i].lat];
						then.$emit('showAddress', pos, then.mapDeviceList[i].formattedAddress)
						openInfoWin(mark.getPosition());
					});
					then.map.on('click', () => {
						infoWindow.close()
					})
					openInfoWin();
				}
			},
			searchAddress() {
				this.isSearch = true;
				this.placeSearch.search(this.search_data);
			},
			closeSearch(){
				this.search_data = '';
				this.isSearch = false;
			},
			selectAddress(e) {
				//这里获得点选地点的经纬度
				let location = e.selected.data.location;
				console.log('lng', location.lng);
				console.log('lat', location.lat);
			},
			changeToDraw() {
				this.isDraw = !this.isDraw;
				if (this.isDraw) {
					this.mouseTool = new AMap.MouseTool(this.map)
					this.drawRectangle(this.mouseTool, this.map);
				} else {
					this.mouseTool.close();
					this.mouseTool = null;
					return false;
				}
			},
			setDeviceToMap() {

			},
			addTools(map) {
				AMap.plugin('AMap.MapType,AMap.ToolBar,AMap.Scale,AMap.Geocoder,AMap.MouseTool',
					function() { //异步加载插件 起作用的是这里
						let MapType = new AMap.MapType({
							defaultType: 0
						});
						let ToolBar = new AMap.ToolBar();
						let Scale = new AMap.Scale();
						map.addControl(MapType);
						map.addControl(ToolBar);
						map.addControl(Scale);
					});
			},
			changeMap() {
				if (this.mapType == "normal") {
					this.mapType = "Satellite";
				} else {
					this.mapType = "normal";

				}
			},
			async regeoCode(lnglat) {
				//console.log(lnglat)
				this.geocoder.getAddress(lnglat, (status, result) => {
					if (status === 'complete' && result.regeocode) {
						this.address = result.regeocode.formattedAddress;
						this.markDetail.citycode = result.regeocode.addressComponent.citycode;
						this.markDetail.adcode = result.regeocode.addressComponent.adcode;
						this.markDetail.address = result.regeocode.formattedAddress;
						this.markDetail.position = lnglat;
						this.$emit('amapData', this.markDetail)
						this.$emit('showAddress', lnglat, this.address)
						//console.log('完成')
						return true
					} else {
						this.$msg({
							type: 'warning',
							message: this.$t('terminal.matTip2')
						})
						return false;
					}
				})
			},
			drawRectangle(mouseTool, map) {
				let then = this;
				mouseTool.rectangle({
					strokeColor: 'black',
					strokeOpacity: 0,
					strokeWeight: 1,
					fillColor: '',
					fillOpacity: 0,
					// strokeStyle还支持 solid
					strokeStyle: 'solid',
					// strokeDasharray: [30,10],
				})
				let mouse = function(event) {
					// event.obj 为绘制出来的覆盖物对象
					//console.log('覆盖物对象绘制完成', event.obj.getPath())
					let left_top = event.obj.getPath()[2];
					let right_bottom = event.obj.getPath()[0];
					//console.log('left_top',left_top.lat,left_top.lng)
					//console.log('right_bottom',right_bottom.lat,right_bottom.lng)
					//console.log('device',then.mapDeviceList)
					let orderDevice = [];
					if (then.mapDeviceList.length != 0) {
						then.mapDeviceList.forEach(ele => {
							if (Number(ele.lat) > left_top.lat && Number(ele.lat) < right_bottom.lat && Number(
									ele.lng) < left_top.lng && Number(ele.lng) > right_bottom.lng) {
								orderDevice.push({
									name: ele.name,
									id: ele.id,
									type_id: ele.type_id,
									sn: ele.sn
								})
							}
						})
					}
					then.$emit('seleceDevice', orderDevice);
					//console.log(orderDevice);
				}
				if (this.isDraw) {
					mouseTool.on('draw', mouse)
					map.on('mousedown', function() {
						let polyArr = map.getAllOverlays('polygon');
						if (polyArr.length != 0) {
							map.remove(polyArr);
						}
					})
				} else {
					mouseTool.close();
				}
			},
			async getLng(map) { //点击获取经纬度
				//let map = new AMap.Map('container');
				// if(this.currentMark!=null){
				// 	map.remove(this.currentMark)
				// }
				map.on('click', (e) => {
					this.latlng = [e.lnglat.getLng(), e.lnglat.getLat()];
					if (this.currentMark != null) {
						map.remove(this.currentMark)
					}
					this.currentMark = new AMap.Marker({
						position: this.latlng,
					});
					this.currentMark.setLabel(({
						content: this.deviceName,
						direction: 'bottom'
					}))
					//
					this.regeoCode(this.latlng)
					this.markDetail.position = this.latlng;
					map.add(this.currentMark)
					// if(flag){
					// 	this.$emit('amapData',this.markDetail)
					// }
					console.log('marker', this.markDetail)
				})
			}
		},
		watch:{
			// deviceList(){
			// 	//设备变化，重新加载标记
			// 	this.deviceList.forEach(ele => {
			// 		if (ele.lat !== null && ele.lng !== null && ele.lat != '0.0000000000') {
			// 			ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
			// 			ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
			// 			this.mapDeviceList.push(ele);
			// 			AMap.SimpleMarker({
			// 				iconTheme:'default',
			// 				iconStyle:'lightgray',
			// 				iconLabel:{
			// 					style:{
			// 						color:'red'
			// 					}
			// 				}
			// 			})
			// 			// let mark = new SimpleMarker({
			// 			// 	iconTheme: iconTheme,
			// 			// 	iconStyle: 'lightgray',
			// 			// 	iconLabel: {
			// 			// 		style: {
			// 			// 			color: '#333'
			// 			// 		}
			// 			// 	},
			// 			// 	map: then.map,
			// 			// 	position: [Number(then.mapDeviceList[i].lng), Number(then.mapDeviceList[i].lat)],
			// 			// 	label: {
			// 			// 		content: then.mapDeviceList[i].name,
			// 			// 		offset: new AMap.Pixel(27, 25)
			// 			// 	}
			// 			// })
			// 		}
			// 	})
			// 	console.log('watch',this.deviceList)
			// }
		}
	}
</script>

<style lang="scss" scoped>
	.device-map {
		width: 100%;
		height: 100%;

		.area {
			height: 40px;
		}

		.dmap {
			width: 98%;
			height: 100%;
			margin: 0 auto;
			position: relative;

			.isdraw {
				position: absolute;
				width: 30px;
				height: 30px;
				font-size: 20px;
				left: 0;
				top: 50%;
				z-index: 1999;
				transform: translate(12px, -70px);

				img {
					width: 50px;
					height: 50px;
				}
			}

			.input-search {
				position: absolute;
				top: 10px;
				right: 75px;
				display: flex;
				justify-content: space-between;
				.panel{
					position: absolute;
					top: 40px;
					width: 205px;
					height: 200px;
					overflow: auto;
				}
				.close{
					font-size: 20px;
					position: absolute;
					right: 10px;
					top: 12px;
					//transform: translate(-50%);
					z-index: 2000;
				}
			}
		}

		.dmapShowAre {
			height: calc(100% - 40px)
		}

		.inner {
			height: 300px;
			overflow: auto;
		}
	}
</style>
